import {
  baseCompanyZh,
  companyProfile,
  legacyAboutPage,
  legacyContactPage,
  quickLinksZh,
  zhPreview
} from './shared'

export const zhSite = {
    lang: 'zh',
    company: baseCompanyZh,
    nav: [
      { key: 'home', name: '首页', path: '/index' },
      { key: 'product', name: '核心产品', path: '/product' },
      { key: 'about', name: '企业简介', path: '/about' },
      { key: 'contact', name: '联系我们', path: '/contact' }
    ],
    labels: {
      language: '中文',
      switchLanguage: 'EN',
      businessContact: '商务咨询',
      contactUs: '联系我们',
      learnCompany: '了解公司',
      learnMore: '了解更多',
      backHome: '返回首页',
      cooperation: '合作沟通',
      quickLinks: '快速链接',
      contactInfo: '联系方式',
      phone: '联系电话',
      email: '商务合作',
      address: '联系地址',
      qrText: '扫码关注',
      rights: '版权所有',
      phoneAction: '电话联系',
      emailAction: '发送邮件'
    },
    home: {
      hero: {
        eyebrow: '临床研究协作',
        title: '让临床研究工作在可信流程中协同推进',
        description:
          '从方案建模、现场采集到质量核查和分析发布，乐康帮助研究团队减少断点、保留证据、提升协作效率。',
        notes: ['方案建模', '现场采集', '质量核查', '分析发布'],
        stats: [
          { value: '贯通', label: '研究流程' },
          { value: '协同', label: '多角色任务' },
          { value: '留痕', label: '关键证据' }
        ],
        primaryAction: '了解产品',
        secondaryAction: '联系乐康'
      },
      heroFlow: {
        eyebrow: '研究运行示意',
        title: '数据、任务和智能体进入同一工作流',
        status: '实时协作',
        stages: [
          { number: '01', title: '方案', text: '研究方案与课题设计' },
          { number: '02', title: '采集', text: '中心现场录入与上传' },
          { number: '03', title: '质控', text: '疑问、规则和审计' },
          { number: '04', title: '分析', text: '指标、看板和报告' },
          { number: '05', title: '协作', text: '任务提醒与人工确认' }
        ],
        taskPanel: {
          title: '今日研究任务',
          items: [
            { name: '访视数据核查', state: '待处理' },
            { name: '中心疑问回复', state: '进行中' },
            { name: '周报指标发布', state: '已排程' }
          ]
        },
        agentPanel: {
          title: '智能体辅助',
          text: '识别缺失字段、解释异常趋势、整理下一步任务，所有关键操作由授权人员确认。',
          signals: ['缺失项提示', '异常解释', '报告洞察']
        },
        evidence: ['权限隔离', '审计留痕', '人工确认']
      },
      platformPreview: zhPreview,
      platformHeader: {
        eyebrow: '业务场景',
        title: '围绕临床研究协作的关键场景',
        description:
          '覆盖研究建模、现场采集、质量核查、分析洞察与移动协作，帮助团队在统一流程中推进项目。'
      },
      trustPoints: [
        '多端入口统一接入',
        '贴合临床研究流程',
        '保留上线验收证据'
      ],
      platformModules: [
        {
          number: '01',
          kicker: 'EDC',
          title: '采集和质控',
          text: '管理研究、中心、受试者、访视、CRF、疑问和审计。',
          items: ['研究建模', 'CRF 录入', '疑问闭环']
        },
        {
          number: '02',
          kicker: 'Research',
          title: '个人研究工作台',
          text: '聚合研究范围、角色待办、配置包、录入差异和报告下载。',
          items: ['研究范围', '角色待办', '差异核对']
        },
        {
          number: '03',
          kicker: 'Data',
          title: '分析和大屏',
          text: '连接数据源、数据视图、图表、仪表板、故事板和调度。',
          items: ['数据源', '图表货架', '故事板']
        },
        {
          number: '04',
          kicker: 'Mobile',
          title: '移动现场协作',
          text: '用微信小程序承接现场录入、附件上传、疑问处理和签名确认。',
          items: ['现场录入', '附件上传', '签名确认']
        }
      ],
      productHeader: {
        eyebrow: '产品入口',
        title: '从真实工作流进入核心产品',
        description:
          '以研究团队的日常流程为线索，快速进入采集、协作、分析和移动执行能力。',
        action: '查看核心产品'
      },
      products: [
        {
          kicker: '01',
          title: '研究设计与采集',
          path: '/product',
          summary: '把方案、中心、受试者、访视和表单放入统一数据模型。',
          points: ['研究结构', '现场录入', '审计证据']
        },
        {
          kicker: '02',
          title: '角色协作与质控',
          path: '/product',
          summary: '让研究者、协调员、监查员和数据管理员围绕同一任务闭环协作。',
          points: ['范围切换', '任务队列', '疑问处理']
        },
        {
          kicker: '03',
          title: '分析洞察与发布',
          path: '/product',
          summary: '从数据源、视图和图表生成看板、故事板和运营报告。',
          points: ['指标视图', '可视化看板', '调度发布']
        },
        {
          kicker: '04',
          title: '移动现场执行',
          path: '/product',
          summary: '用小程序承接现场任务、附件上传、疑问回复和签名确认。',
          points: ['小程序入口', '附件采集', '签名确认']
        }
      ],
      deliveryHeader: {
        eyebrow: '落地方式',
        title: '从场景梳理到上线运营，保留可复演的证据链',
        description:
          '通过数据复演、权限抽样、流程核验和回退预案，让上线决策建立在清晰证据之上。'
      },
      deliveryFlow: [
        {
          step: '01',
          title: '梳理场景',
          text: '确认研究、角色、流程、数据来源和报表目标。'
        },
        {
          step: '02',
          title: '配置平台',
          text: '配置用户权限、表单流程、数据源和移动入口。'
        },
        {
          step: '03',
          title: '数据复演',
          text: '开展迁移演练、计数对账和关键流程核验。'
        },
        {
          step: '04',
          title: '上线运营',
          text: '执行发布、监控、回退预案和持续优化。'
        }
      ],
      clientsHeader: {
        eyebrow: '合作客户',
        title: '长期服务医疗机构与科研场景',
        description: '以真实合作经验和可验证交付成果，支撑平台持续演进。'
      },
      clients: [
        {
          name: '江苏省人民医院',
          logo: require('@/assets/images/logo/srm.jpeg')
        },
        {
          name: '江苏省妇幼保健院',
          logo: require('@/assets/images/logo/jsfy.png')
        },
        {
          name: '南京鼓楼医院',
          logo: require('@/assets/images/logo/njgl.webp')
        },
        {
          name: '江苏省中医院',
          logo: require('@/assets/images/logo/jsszy.webp')
        },
        {
          name: '中国人民武装警察部队特色医学中心',
          logo: require('@/assets/images/logo/wj.jpg')
        },
        {
          name: '江苏省苏北人民医院',
          logo: require('@/assets/images/logo/jssb-optimized.webp')
        },
        {
          name: '连云港市第一人民医院',
          logo: require('@/assets/images/logo/lygrm-optimized.webp')
        },
        {
          name: '连云港市妇幼保健院',
          logo: require('@/assets/images/logo/lygfy.webp')
        }
      ],
      aboutPreview: {
        eyebrow: '关于乐康',
        title: '以可信医疗数据平台服务长期协作',
        description:
          '乐康数科专注医疗与科研数据平台建设，坚持以清晰模型、稳定流程和可追溯机制支撑客户的数字化实践。',
        image: legacyAboutPage.intro.image
      },
      contactCta: {
        eyebrow: '商务合作',
        title: '欢迎沟通项目场景与建设目标',
        description:
          '无论是临床研究平台、研究工作台、数据分析中心还是移动协作应用，我们都可以基于实际场景提供建设建议。'
      }
    },
    productPage: {
      eyebrow: '核心产品',
      label: '临床研究数据协同平台',
      title: '面向临床研究的统一数据协同平台',
      intro:
        'Alekang 连接研究设计、现场采集、质量核查、数据分析和移动协作，让多角色在同一套可信流程中完成研究工作。',
      bannerPreview: {
        theme: 'data',
        eyebrow: '指挥中心',
        title: '临床研究指挥中心',
        subtitle: '研究、中心、受试者、质量风险和智能体协同呈现在同一视图',
        status: '实时协作',
        pill: '审计留痕',
        metrics: [
          { label: '在研项目', value: '12' },
          { label: '待处理疑问', value: '48' },
          { label: '本周录入', value: '326' }
        ],
        panels: [
          {
            title: '研究运行',
            items: ['中心启用', '受试者入组', '访视执行']
          },
          {
            title: '质量态势',
            bars: [
              { label: '数据完整率', value: '91%', ratio: 91 },
              { label: '疑问关闭率', value: '84%', ratio: 84 },
              { label: '中心响应率', value: '88%', ratio: 88 }
            ]
          },
          {
            title: '智能体提示',
            tags: ['方案配置', '异常解释', '报表洞察', '任务提醒']
          }
        ],
        footer: ['研究范围', '权限边界', '质量证据']
      },
      bannerCaption: '以研究流程为主线，把数据采集、质量管理、分析洞察和智能辅助放在同一张工作图中。',
      highlights: [
        'EDC 采集',
        'CRF 质控',
        '研究协作',
        '分析大屏',
        '智能体辅助',
        '审计留痕'
      ],
      audiences: {
        eyebrow: '适用角色',
        title: '为研究各方提供一致的数据视图',
        items: [
          { name: '申办方', text: '掌握研究进度、中心质量和风险趋势。' },
          { name: 'CRO', text: '统一跟踪执行、监查、疑问和交付证据。' },
          { name: '研究中心', text: '按研究范围处理受试者、访视和表单任务。' },
          { name: '研究者', text: '聚合个人待办、签名确认和报告查看。' },
          { name: '数据管理员', text: '集中处理质控规则、疑问闭环和数据锁定。' },
          { name: '运营管理者', text: '用看板和调度任务管理跨项目运行。' }
        ]
      },
      solutionHeader: {
        eyebrow: '解决方案',
        title: '按研究流程组织产品能力',
        description:
          '从采集、协作、分析、移动到治理，每个产品对应明确业务场景，便于按研究阶段和角色组合使用。'
      },
      agentLayer: {
        eyebrow: '智能体能力层',
        title: '辅助配置、核查、分析和运营，不替代人工确认',
        items: ['方案生成辅助', 'CRF 核查建议', '异常解释', '报表洞察', '任务提醒'],
        guardrails: ['人工确认', '权限隔离', '审计留痕']
      },
      solutions: [
        {
          id: 'capture',
          kicker: '临床试验采集',
          title: 'EDC 采集与研究质控',
          text:
            '面向注册研究、观察性研究和多中心项目，把研究设计、中心启用、受试者、访视、CRF、疑问和审计组织成连续闭环。',
          tags: ['研究设计', '受试者入组', 'CRF 录入', '疑问闭环'],
          agent:
            '智能体辅助生成访视结构、字段校验和疑问初筛建议，最终配置由授权人员确认。',
          visual: {
            type: 'capture',
            eyebrow: 'EDC 生命周期',
            title: '从方案到数据锁定',
            stages: [
              { step: '01', title: '方案设计', meta: '研究、中心、访视与 CRF 建模' },
              { step: '02', title: '中心启用', meta: '授权、参数和角色范围确认' },
              { step: '03', title: '受试者入组', meta: '筛选、入组、分组和基线采集' },
              { step: '04', title: '访视执行', meta: '表单录入、附件和疑问处理' },
              { step: '05', title: '数据锁定', meta: '审计核对、导出和归档证据' }
            ],
            signals: ['缺失项', '逻辑冲突', '异常值', '审计轨迹']
          }
        },
        {
          id: 'workspace',
          kicker: '研究者协作',
          title: '个人研究工作台',
          text:
            '为研究者、协调员、监查员和数据管理员提供独立入口，把研究范围、任务队列、配置包、录入差异和报告下载聚合到个人视图。',
          tags: ['研究范围', '角色待办', '配置包', '差异核对'],
          agent:
            '智能体按角色整理优先级，解释异常原因，并生成核查摘要供人工复核。',
          visual: {
            type: 'workspace',
            eyebrow: '任务工作台',
            title: '角色任务驾驶舱',
            contexts: ['当前研究', '当前中心', '个人权限', '最近对象'],
            columns: [
              { title: '今日待办', items: ['访视确认', '签名待处理', '报告下载'] },
              { title: '数据问题', items: ['疑问回复', '差异核对', '附件补充'] },
              { title: '分析任务', items: ['配置确认', '结果复核', '导出申请'] }
            ],
            alerts: ['逾期提醒', '高风险记录', '待确认配置']
          }
        },
        {
          id: 'analytics',
          kicker: '数据分析',
          title: '数据分析与可视化大屏',
          text:
            '面向项目管理、质量管理和经营分析，提供数据源、数据视图、图表货架、仪表板、故事板和调度发布能力。',
          tags: ['数据源', '数据视图', '图表货架', '故事板'],
          agent:
            '智能体把自然语言问题转化为指标草案、图表建议和结果摘要，帮助团队更快形成洞察。',
          visual: {
            type: 'analytics',
            eyebrow: 'Datart / GoView',
            title: '数据到故事板',
            sources: ['数据源', 'SQL 视图', '图表货架', '仪表板'],
            metrics: ['入组趋势', '疑问关闭率', '中心质量'],
            shelfTitle: '字段货架',
            shelf: ['维度：中心', '指标：入组数', '筛选：研究阶段', '排序：风险等级'],
            bars: [
              { label: '入组', value: 86 },
              { label: '质量', value: 73 },
              { label: '响应', value: 91 }
            ],
            table: ['中心排名', '风险清单', '调度发布']
          }
        },
        {
          id: 'mobile',
          kicker: '移动采集',
          title: '微信小程序移动端',
          text:
            '针对研究现场和随访场景，支持受试者查询、访视处理、CRF 录入、附件上传、疑问处理和签名确认。',
          tags: ['小程序入口', '现场录入', '附件上传', '疑问处理'],
          agent:
            '智能助手在小屏内提示缺失项、异常值和下一步动作，降低现场漏填和返工。',
          visual: {
            type: 'mobile',
            eyebrow: '移动 EDC',
            title: '现场操作',
            phoneTitle: '访视任务',
            subject: '受试者 S-042 · 第 3 次访视',
            fields: ['生命体征', '合并用药', '不良事件', '附件照片'],
            action: '保存并提交',
            assistant: ['2 项必填未完成', '收缩压超出阈值', '建议创建疑问']
          }
        },
        {
          id: 'governance',
          kicker: '科研数据治理',
          title: '研究数据资产与治理',
          text:
            '沉淀研究对象、字段标准、字典版本、权限边界、数据血缘和质量规则，为跨项目复用、统计分析和科研产出提供基础。',
          tags: ['数据标准', '质量规则', '权限边界', '审计证据'],
          agent:
            '智能体辅助识别字段语义、推荐标准字典和质量规则，结果进入可追溯的人工审核流程。',
          visual: {
            type: 'catalog',
            eyebrow: '数据治理',
            title: '资产血缘与规则',
            lineage: ['研究对象', '采集字段', '标准字典', '分析指标'],
            groups: [
              { name: '标准', items: ['字段', '字典', '单位', '版本'] },
              { name: '质量', items: ['规则', '核查', '阈值', '追踪'] },
              { name: '权限', items: ['角色', '范围', '脱敏', '审批'] }
            ],
            policies: ['租户隔离', '角色授权', '敏感字段保护', '全程审计']
          }
        }
      ],
      summary: {
        eyebrow: '产品价值',
        title: '以一套平台承接多角色研究协作',
        text: '产品可以独立启用，也可以组合成完整临床研究平台，关键数据、权限和审计证据保持一致。',
        items: ['统一入口', '角色协作', '质量闭环', '智能辅助']
      },
      cta: {
        title: '需要匹配自身研究场景的产品方案？',
        description:
          '欢迎联系我们，基于研究类型、角色分工和数据来源评估建设路径。'
      }
    },
    aboutPage: {
      ...legacyAboutPage,
      hero: {
        eyebrow: '关于我们',
        title: '专注临床研究与医疗数据协同平台建设',
        description:
          '乐康数科以医疗和科研场景为核心，持续打磨可信、稳定、可运营的数据平台能力。',
        image: legacyAboutPage.hero.image
      },
      intro: {
        title: '公司简介',
        lead: '南京乐康数字科技有限公司专注临床研究与医疗数据协同平台建设，服务医疗机构、科研团队和公共卫生场景。',
        paragraphs: [
          '我们关注的不只是系统上线，更关注数据能否长期保持清晰、一致、可信和可追溯。',
          '通过统一对象模型、权限边界、流程治理和报表分析，帮助客户降低跨角色、跨机构协作成本。'
        ],
        bullets: [
          '规范采集：统一研究对象和数据口径。',
          '可信治理：保留过程记录和审计证据。',
          '安全协同：支撑多机构、多角色稳定协作。'
        ],
        image: legacyAboutPage.intro.image
      },
      valuesTitle: {
        eyebrow: '使命与愿景',
        title: '让医疗数据协作更清晰、更可信'
      },
      values: [
        {
          title: '使命',
          text: '以规范采集、可信治理和安全协同提升临床研究数据质量',
          icon: legacyAboutPage.values[0].icon
        },
        {
          title: '愿景',
          text: '成为值得信赖的医疗数据协同平台服务商',
          icon: legacyAboutPage.values[1].icon
        },
        {
          title: '原则',
          text: '坚持清晰、可靠、可追溯的产品建设方式',
          icon: legacyAboutPage.values[2].icon
        },
        {
          title: '定位',
          text: '服务医疗机构、科研团队和长期运营场景',
          icon: legacyAboutPage.values[3].icon
        }
      ],
      timelineTitle: {
        eyebrow: '发展历程',
        title: '在真实场景中持续完善产品能力'
      },
      timeline: [
        { year: '2026年', title: '智能临床研究平台 2.0 上线' },
        { year: '2025年', title: '慢性便秘临床研究平台上线' },
        { year: '2024年', title: '市级筛查平台上线并稳定运行' },
        { year: '2023年', title: '乐康数科独立运营', highlight: true },
        { year: '2022年', title: '推进院内外慢病协作服务' },
        { year: '2021年', title: '健康管理平台完成升级' },
        { year: '2018年', title: '健康管理平台投入应用' }
      ]
    },
    contactPage: {
      ...legacyContactPage,
      hero: {
        eyebrow: '联系我们',
        title: '欢迎沟通平台建设需求',
        description:
          '请说明业务场景、建设阶段和优先目标，我们会给出更清晰的产品和实施建议。'
      },
      infoTitle: {
        eyebrow: '联系信息',
        title: '沟通入口',
        description: '可通过电话、邮箱或公众号与我们取得联系。'
      },
      cta: {
        eyebrow: '合作引导',
        title: '已有明确场景时，沟通会更高效',
        description: '建议同步说明业务方向、当前系统、数据来源和期望上线时间。'
      },
      qrText: '扫码关注，保持长期沟通'
    },
    quickLinks: quickLinksZh
  }
